import React, { useEffect } from 'react';
import { PhoneCall } from 'lucide-react';

const CALENDLY_URL =
  'https://calendly.com/wholesome360-info?hide_gdpr_banner=1&primary_color=245a40&text_color=1b2a22&background_color=ffffff';

export const CalendlyBooking = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <section className="mt-16" data-testid="calendly-section">
      <div className="bg-[#245A40] rounded-3xl p-8 sm:p-12 overflow-hidden">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] text-[#E8C56B] font-semibold">
            <PhoneCall className="w-4 h-4" /> Book a Call
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-[#F6F2E8] mt-3 leading-[1.08]">
            Not sure where to start? <em className="text-[#E8C56B] not-italic">Schedule a call</em> with our catering manager.
          </h2>
          <p className="mt-4 text-white/85 text-base sm:text-lg">
            Pick a time that works for you — we&rsquo;ll help plan the menu, headcount and logistics in 15 minutes.
          </p>
        </div>
        <div className="mt-8 bg-white rounded-2xl overflow-hidden shadow-xl" data-testid="calendly-embed">
          <div
            className="calendly-inline-widget"
            data-url={CALENDLY_URL}
            style={{ minWidth: '320px', height: '700px' }}
          />
        </div>
      </div>
    </section>
  );
};
